const global = globalThis || void 0 || self;

export { global as default, global };
//# sourceMappingURL=index.js.map
